import React, { useEffect, useState } from 'react';
import { Container } from 'reactstrap';
import { ToastContainer } from 'react-toastify';

import { ContentSection } from './ContentSection';
import { FolderTreeSection } from './FolderTreeSection';
import { DetailSection } from './DetailSection';
import { FilterContentSection } from './FilterContentSection';
import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';

const FileManager = () => {
	const [filterActive, setFilterActive] = useState('Unidad Compartida');

	// Folders
	const [current_folder, setCurrent_Folder] = useState({ name: 'Unidad Compartida', _id: '/', });

	const selectorProfile = createSelector(
        state => state.Profile,
        profile => ({
            establishmentActive: profile.establishmentActive
        })
    );
    const { 
        establishmentActive
    } = useSelector(selectorProfile);

	// SideBar Open

	// function sidebarOpen(value) {
	// 	const element = document.body;
	// 	element.classList.add(value);
	// }

	// useEffect(() => {
	// 	sidebarOpen('file-detail-show');
	// }, []);

	// const fileSidebar = () => {
	// 	document.getElementById('folder-overview').style.display = 'none';
	// 	document.getElementById('file-overview').style.display = 'block';
	// };

	return (
		<React.Fragment>
			<ToastContainer closeButton={false} />
			{/* <DeleteModal
				show={deleteModal}
				onDeleteClick={() => handleDeleteFolder()}
				onCloseClick={() => setDeleteModal(false)}
			/> */}

			<div className='page-content'>
				<Container fluid>
					<div className='chat-wrapper gap-1 mx-n4 mt-n4 p-1 content-file-manager'>
						<FolderTreeSection
							filterActive={filterActive}
							setFilterActive={setFilterActive}
							current_folder={current_folder}
							setCurrent_Folder={setCurrent_Folder}
							establishmentId={establishmentActive?.item?._id || null}
						/>
						{filterActive === 'Unidad Compartida' ? (
							<ContentSection
								key={'content_section_' + establishmentActive?._id || ''}
								current_folder={current_folder}
								setCurrent_Folder={setCurrent_Folder}
								establishmentId={establishmentActive?.item?._id || null}
							/>
						) : (
							<FilterContentSection
								filterActive={filterActive}
							/>
						)}
						{/* <DetailSection /> */}
					</div>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default FileManager;
